import { gql } from '@apollo/client'

export const GET_ONE_FORM_BY_ID = gql`
  query GetOneFormById($formId: Int!) {
    getOneFormById(formId: $formId) {
      id
      name
      description
      diplay_name
      display_name_plural
      icon
      id_user_register
      GroupsCategoriesSubOfForm {
        id
        name
      }
      FieldsOfForm {
        id
        form_id
        label
        name
        placeholder
        field_type_id
        field_type_choosen_source_id
        order
        col_width
        file_types_allowed
        TypeOfField {
          id
          name
          description
          type
        }
        TypeChoosenSourceOfField {
          id
          source_table
          key
          label
          source_json
        }
        FieldYupRulesOfFormField {
          id
          field_id
          yup_rule_id
          YupRuleOfField {
            id
            description
            yup_type
            yup_rule
            options
            message
            active_on_web
          }
        }
      }
    }
  }
`

export const GET_ALL_FORMS = gql`
  query GetAllForms($searchQuery: String, $limit: Int, $offset: Int) {
    getAllForms(searchQuery: $searchQuery, limit: $limit, offset: $offset) {
      rows {
        id
        name
        description
        diplay_name
        display_name_plural
        icon
        id_user_register
        FieldsOfForm {
          id
        }
      }
      count
    }
  }
`

export const CREATE_FORM = gql`
  mutation CreateForm($input: FormInput!) {
    createForm(input: $input)
  }
`

export const UPDATE_FORM = gql`
  mutation UpdateForm($formId: Int!, $input: FormInput!) {
    updateForm(formId: $formId, input: $input)
  }
`

export const DELETE_FORM = gql`
  mutation DeleteForm($id: Int!) {
    deleteForm(id: $id)
  }
`
